import 'bootstrap/dist/css/bootstrap.min.css';
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import LoginPage from './LoginPage';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter, Route , Routes } from 'react-router-dom';
import Home from './Home';
import ProtectedRoute from './ProtectedRoute';
import NotFound from './NotFound';
import Offers from './OffersPage';
import PaymentPage from './PaymentPage';
import OperationsPage from './OperationsPage';
import Maintenance from './Maintenance';
import ResultPage from './ResultPage';
import RegisterPage from './RegisterPage';
import TermsPage from './TermsPage';
import ForgetPassword from './ForgetPassword';
import ResetPassword from './ResetPassword';
const root = ReactDOM.createRoot(document.getElementById('root'));
// // Clear all caches
// if ('serviceWorker' in navigator) {
//     navigator.serviceWorker.getRegistrations().then(registrations => {
//         for (let registration of registrations) {
//             registration.unregister();
//         }
//     });
// }

// // Clear localStorage and sessionStorage
// localStorage.clear();
// sessionStorage.clear();

// Clear browser cache (limited effectiveness, works only for cache API)
if ('caches' in window) {
    caches.keys().then(keys => {
        keys.forEach(key => caches.delete(key));
    });
}
root.render(
    <BrowserRouter >
     <Routes>
        <Route path="/register" element={<RegisterPage/>} />
        <Route path="/login" element={<LoginPage/>} />
        <Route path="/terms" element={<TermsPage/>} />
        <Route path="/forgot-password" element={<ForgetPassword/>} />
        <Route path="/reset-password" element={<ResetPassword/>} />
        <Route path="/" element={<ProtectedRoute/>} >
        <Route index element={<Home/>} />
        <Route path="operations" element={<OperationsPage/>} />
        <Route path="offers/:number" element={<Offers/>} />
        <Route path="/payment" element={<PaymentPage/>} />
        <Route path="result" element={<ResultPage/>} />
        </Route>
        <Route path="*" element={<NotFound />} />
        {/* <Route path="*" element={<Maintenance />} /> */}
        </Routes>
    </BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
